import { useEffect, useState } from "react";
import servicosColaborador from "../servicos/servicos-colaborador";
import servicosCargo from "../servicos/servicos-cargo";
import servicosSetor from "../servicos/servicos-setor";
import MenuLateral from "./components/MenuLateral";
import NavMenu from "./components/Nav";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from 'react-toastify';
import { useForm } from "react-hook-form";
import Salvar from "../img/svgs/Salvar";
import InputMask from 'react-input-mask';




export default function CadastroColaborador() {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [setores, setSetores] = useState(null);
    const [cargos, setCargos] = useState(null);
    const [dadosColaborador, setDadosColaborador] = useState({
        "id_setor": 0,
        "id_cargo": 0,
        "matricula": 0,
        "nome": "",
        "cpf": "",
        "rg": "",
        "data_nascimento": "",
        "data_admissao": "",
        "email": "",
        "telefone": "",
        "nacionalidade": "Brasil",
        "endereco": "",
        "complemento": "",
        "bairro": "",
        "numero": "",
        "cep": "",
        "AI": "A",
        "acesso": "simples"
    })
    const [data, setData] = useState(dadosColaborador);
    const [valido, setValido] = useState(false);
    const [adicionado, setAdicionado] = useState(false);
    const [setoresCarregados, setSetoresCarregados] = useState(false);
    const [cargosCarregados, setCargosCarregados] = useState(false);

    useEffect(() => {
        setValido(data.id_setor > 0 && data.id_cargo > 0 ? false : true)
    }, [data.id_cargo, data.id_setor, valido])

    useEffect(() => {
        function getDados() {
            servicosSetor.listarTodos()
                .then(response => {
                    if (response.status === 200) {
                        setSetores(response.data);
                        setSetoresCarregados(true);
                    }
                }).catch((error) => {
                    console.log(error);
                });
        }
        getDados();
    }, []);

    useEffect(() => {
        function getDados() {
            servicosCargo.listarTodos()
                .then(response => {
                    if (response.status === 200) {
                        setCargos(response.data);
                        setCargosCarregados(true);
                    }
                }).catch((error) => {
                    console.log(error);
                });
        }
        getDados();
    }, []);

    const handleChange = (e) => {
        let { name, value } = e.target;
        if (name === 'matricula' || name === "id_setor" || name === "id_cargo" || name === "numero") {
            value = Number(value);
        }
        setData({ ...data, [name]: value });

    }

    const SelectSetores = () => {
        if (!setoresCarregados) {
            return <>Carregando lista de setores</>
        } else {

            return (
                <>
                    <Form.Group className="mb-3" controlId="setor">
                        <Form.Label className="label-texto">Setor</Form.Label>
                        <select className="form-select input-cadastro" id="id_setor" name="id_setor" tabIndex={3} onChange={handleChange} aria-label="" value={data.id_setor}>
                            <option value={0}>Selecione</option>
                            {setores.map((item) => {
                                const id = item.id_setor;
                                return <option key={id} value={id}>{item.nome_setor}</option>
                            })}
                        </select>
                    </Form.Group>
                </>
            )
        }
    }
    const SelectCargos = () => {
        if (!cargosCarregados) {
            return <>Carregando lista de cargos</>
        } else {
            return (
                <>
                    <Form.Group className="mb-3" controlId="cargo">
                        <Form.Label className="label-texto">Cargo</Form.Label>
                        <select className="form-select input-cadastro " name="id_cargo" tabIndex={2} onChange={handleChange} aria-label="" defaultValue={data.id_cargo}>
                            <option value={0}>Selecione</option>
                            {cargos.map((item) => {
                                const id = item.id_cargo;
                                return <option key={id} value={id}>{item.nome_cargo}</option>
                            })}
                        </select>
                    </Form.Group>
                </>
            )
        }
    }

    const SelectAcesso = () => {
        if (cargos === null) {
            return <>Carregando lista de cargos</>
        }
        return (
            <>
                <Form.Group className="mb-3" controlId="acesso">
                    <Form.Label className="label-texto">Acesso</Form.Label>
                    <select className="form-select input-cadastro " tabIndex={1} name="acesso" onChange={handleChange} aria-label="" defaultValue={data.acesso}>
                        <option value="admin">Admin</option>
                        <option value="gestor">Gestor</option>
                        <option value="master">Master</option>
                        <option value="simples">Simples</option>
                        <option value="vip">Vip</option>
                    </select>
                </Form.Group>
            </>
        )
    }


    const criarColaborador = () => {
        servicosColaborador.create(data)
            .then(response => {
                if (response.status === 201) {
                    toast.success("Colaborador adicionado com sucesso!", {
                        theme: "colored",
                    });
                    setAdicionado(true);
                    window.location.reload();
                    setDadosColaborador("")
                } else {
                    toast.error(response.data.message, {
                        theme: "colored"
                    });
                }
            }).catch(error => {
                toast.error("Não foi possível cadastrar o Colaborador!", {
                    theme: "colored"
                });
                console.log(error);
            })
    }

    return <>
        <NavMenu />
        <ToastContainer />
        <div className="d-flex container">
            <div className="w-25">
                <MenuLateral />
            </div>
            <div className="w-75 d-flex justify-content-center align-items-center ">
                {adicionado === false ? <form className="" onSubmit={handleSubmit(criarColaborador)}>
                    <div className="">
                        <h3 className="text-center">Cadastro de Colaboradores</h3>
                        <div className="form-colaborador tabela d-flex">
                            <div className="me-5">
                                <SelectAcesso />
                                <SelectSetores />
                                <Form.Group className="mb-3 disabled" controlId="nome" >
                                    <Form.Label className="label-texto">Nome</Form.Label>
                                    <Form.Control
                                        tabIndex={5}
                                        className="input-cadastro "
                                        type="text"
                                        name="nome"
                                        {...register("nome", { required: true, minLength: 2 })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.nome && <p className="errosValidacao">Requerido</p>}

                                <Form.Group className="mb-3" controlId="matricula">
                                    <Form.Label className="label-texto">Matrícula</Form.Label>
                                    <Form.Control
                                        tabIndex={7}
                                        className="input-cadastro"
                                        type="number"
                                        name="matricula"
                                        {...register("matricula", { required: true })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.matricula && <p className="errosValidacao">Requerido</p>}

                                <Form.Group className="mb-3 d-flex row" style={{ marginLeft: 2 }} controlId="telefone">
                                    <Form.Label className="label-texto">Telefone</Form.Label>
                                    <InputMask
                                        tabIndex={9}
                                        className="input-cadastro"
                                        mask="(99) 99999-9999"
                                        placeholder="(00) 00000-0000"
                                        type="text"
                                        name="telefone"
                                        {...register("telefone", { required: true })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.telefone && <p className="errosValidacao">Requerido</p>}


                                <Form.Group className="mb-3" controlId="endereco">
                                    <Form.Label className="label-texto">Endereço</Form.Label>
                                    <Form.Control
                                        tabIndex={11}
                                        className="input-cadastro"
                                        type="text"
                                        name="endereco"
                                        {...register("endereco", { required: true })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.endereco && <p className="errosValidacao">Requerido</p>}




                                <Form.Group className="mb-3" controlId="numero">
                                    <Form.Label className="label-texto">Complemento</Form.Label>
                                    <Form.Control
                                        tabIndex={13}
                                        className="input-cadastro"
                                        type="text"
                                        name="complemento"
                                        {...register("complemento", { required: false })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.complemento && <p className="errosValidacao">Requerido mínimo 2 letras</p>}

                                <Form.Group className="mb-3" controlId="data_nascimento">
                                    <Form.Label className="label-texto">Data de Nascimento</Form.Label>
                                    <Form.Control
                                        tabIndex={15}
                                        className="input-cadastro"
                                        type="date"
                                        name="data_nascimento"
                                        {...register("data_nascimento", { required: true })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.data_nascimento && <p className="errosValidacao">Requerido</p>}

                                <Form.Group className="mb-3" controlId="nacionalidade">
                                    <Form.Label className="label-texto">Nacionalidade</Form.Label>
                                    <Form.Control
                                        tabIndex={17}
                                        className="input-cadastro"
                                        type="text"
                                        name="nacionalidade"
                                        defaultValue={'Brasil'}
                                        {...register("nacionalidade", { required: false })}
                                        onChange={handleChange}

                                    />
                                </Form.Group>
                                {errors.nacionalidade && <p className="errosValidacao">Requerido mínimo 2 letras</p>}



                            </div>
                            <div>
                                <SelectCargos />
                                <Form.Group className="mb-3 d-flex row" style={{ marginLeft: 2 }} controlId="cpf">
                                    <Form.Label className="label-texto">CPF</Form.Label>
                                    <InputMask
                                        tabIndex={4}
                                        className="input-cadastro"
                                        mask="999.999.999-99"
                                        placeholder="000.000.000-00"
                                        type="text"
                                        name="cpf"
                                        {...register("cpf", { required: true })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.cpf && <p className="errosValidacao">Requerido CPF com 11 dígitos</p>}

                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label className="label-texto">E-mail</Form.Label>
                                    <Form.Control
                                        tabIndex={6}
                                        className="input-cadastro"
                                        type="email"
                                        name="email"
                                        {...register("email", { required: true })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.email && <p className="errosValidacao">Requerido</p>}

                                <Form.Group className="mb-3" controlId="rg">
                                    <Form.Label className="label-texto">RG</Form.Label>
                                    <Form.Control
                                        tabIndex={8}
                                        className="input-cadastro"
                                        type="text"
                                        name="rg"
                                        {...register("rg", { required: true })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.rg && <p className="errosValidacao">Requerido</p>}

                                <Form.Group className="mb-3 d-flex row" style={{ marginLeft: 2 }} controlId="cep">
                                    <Form.Label className="label-texto">Cep</Form.Label>
                                    <InputMask
                                        tabIndex={10}
                                        className="input-cadastro"
                                        mask="99999-999"
                                        placeholder="00000-000"
                                        type="text"
                                        name="cep"
                                        {...register("cep", { required: true })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.cep && <p className="errosValidacao">Requerido CEP</p>}

                                <Form.Group className="mb-3" controlId="numero">
                                    <Form.Label className="label-texto">Número</Form.Label>
                                    <Form.Control
                                        tabIndex={12}
                                        className="input-cadastro"
                                        type="number"
                                        name="numero"
                                        {...register("numero", { required: true, minLength: 1 })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.numero && <p className="errosValidacao">Requerido</p>}

                                <Form.Group className="mb-3" controlId="bairro">
                                    <Form.Label className="label-texto">Bairro</Form.Label>
                                    <Form.Control
                                        tabIndex={14}
                                        className="input-cadastro"
                                        type="text"
                                        name="bairro"
                                        {...register("bairro", { required: true })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                {errors.bairro && <p className="errosValidacao">Requerido</p>}

                                <Form.Group className="mb-3" controlId="data_admissao">
                                    <Form.Label className="label-texto">Data de Admissão</Form.Label>
                                    <Form.Control
                                        tabIndex={16}
                                        className="input-cadastro"
                                        type="date"
                                        name="data_admissao"
                                        {...register("data_admissao", { required: true })}
                                        onChange={handleChange}

                                    />
                                </Form.Group>
                                {errors.data_admissao && <p className="errosValidacao">Requerido</p>}



                                <span className="text-center d-flex justify-content-center">

                                    <button tabIndex={20} disabled={valido} type="submit" className="mt-5 p-1 rounded border-1 text-center" ><Salvar /><span> Salvar</span></button>
                                </span>
                            </div>

                        </div>
                    </div>
                </form> : <div>
                    <button className="mt-5 p-1 btn-icones rounded border-1 text-center" onClick={() => setAdicionado(false)}>Adicionar novo colaborador</button>
                </div>}
            </div>

        </div>
    </>
}